import {Tag} from '../models/tag.model';

export class TagsState {
  items: Tag[];
}
